import React from 'react';

const DonateButton = () => (

    <form
    action="https://www.paypal.com/donate"
    method="post"
    target="_top"
  >
    <input
      type="hidden"
      name="hosted_button_id"
      value="S49YSSX7WRUMY"
    />
    <input
      type="image"
      src="https://pics.paypal.com/00/s/MjQxZTE0YmItMzNiZS00YWQzLWJjNWEtNDFiZDc4MWJmMTE3/file.PNG"
      border="0"
      name="submit"
      title="PayPal - The safer, easier way to pay online!"
      alt="Donate with PayPal button"
      className="w-auto h-16 phone:h-16 tablet:h-16"
    />
    <img
      alt=""
      border="0"
      src="https://www.paypal.com/en_US/i/scr/pixel.gif"
      width="1"
      height="1"
    />
  </form>

);

export default DonateButton;